/** True when the payload is a grouped list/detail shape `{ username, data: shards[] }`. */
export function isNestedUsernameDataBundle(row: unknown): row is { username: string; data: unknown[] } {
  if (row === null || typeof row !== 'object') return false;
  const o = row as Record<string, unknown>;
  return typeof o.username === 'string' && Array.isArray(o.data);
}
